import React from 'react'

const Whitelist = () => {
  return (
    <div>Whitelist Page</div>
  )
}

export default Whitelist;